import React from 'react'

import BCA from 'assets/image/customer/logo/bca.png'
import Halodoc from 'assets/image/customer/logo/halodoc.png'
import Zalora from 'assets/image/customer/logo/zalora.png'
import JDID from 'assets/image/customer/logo/jd-id.png'
import Grab from 'assets/image/customer/logo/grab.png'
import Tokopedia from 'assets/image/customer/logo/tokopedia.png'

import Shipper from 'assets/image/customer/logo/shipper.png'
import SunPride from 'assets/image/customer/logo/sunpride.png'
import Sociolla from 'assets/image/customer/logo/sociolla.png'
import Zilingo from 'assets/image/customer/logo/zilingo.png'
import SayurBox from 'assets/image/customer/logo/sayurbox.png'

import OptikSeis from 'assets/image/customer/logo/optik-seis.png'
import SiloamHospital from 'assets/image/customer/logo/siloam-hospital.png'
import DoughLab from 'assets/image/customer/logo/dough-lab.png'
import Mandom from 'assets/image/customer/logo/mandom.png'
import Brodo from 'assets/image/customer/logo/brodo.png'
import Decathlon from 'assets/image/customer/logo/decathlon.png'
import Erigo from 'assets/image/customer/logo/erigo.png'

const Customer = () => {
  return (
    <section id="customer" className="">
      <div className="py-10 px-6 lg:py-[64px] xl:pt-[64px] xl:pb-[90px] max-w-[1440px] m-auto left-0 right-0">
        <div>
          <h1 className="h4-bold lg:h3-bold text-[#101838] text-center">
            Our Customers
          </h1>
          <p className="text-[#969FB6] text-m-reguler mt-2 lg:mt-4 xl:mt-6 text-center">
            Customer’s trust is something that we have build over time.
          </p>
        </div>

        <div className="mt-10 lg:mt-12">
          <div className="wrapper">
            <div className="grid grid-[173px] gap-x-[2px] lg:gap-x-1 gap-y-2 grid-cols-3 sm:grid-cols-6 m-auto left-0 right-0 w-fit">
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[63px] lg:w-[78px] xl:w-[103px]"
                  src={BCA}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[87px] lg:w-[107px] xl:w-[141px]"
                  src={Halodoc}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[84px] lg:w-[103px] xl:w-[136px]"
                  src={Zalora}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[78px] lg:w-[96px] xl:w-[127px]"
                  src={JDID}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[61px] lg:w-[76px] xl:w-[100px]"
                  src={Grab}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[94px] lg:w-[115px] xl:w-[152px]"
                  src={Tokopedia}
                  alt=""
                />
              </div>
            </div>

            <div className="grid grid-[173px] gap-x-[2px] lg:gap-x-1 gap-y-2 grid-cols-3 sm:grid-cols-5 m-auto left-0 right-0 w-fit mt-2">
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[77px] lg:w-[111px] xl:w-[146px]"
                  src={Shipper}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[54px] lg:w-[74px] xl:w-[97px]"
                  src={SunPride}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[76px] lg:w-[104px] xl:w-[137px]"
                  src={Sociolla}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[78px] lg:w-[107px] xl:w-[140px]"
                  src={Zilingo}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[90px] lg:w-[120px] xl:w-[157px]"
                  src={SayurBox}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center sm:hidden">
                <img
                  className="w-[44px] lg:w-[60px] xl:w-[80px]"
                  src={OptikSeis}
                  alt=""
                />
              </div>
            </div>

            <div className="grid grid-[173px] gap-x-[2px] lg:gap-x-1 gap-y-2 grid-cols-3 sm:grid-cols-7 m-auto left-0 right-0 w-fit mt-2">
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] sm:flex items-center justify-center hidden">
                <img
                  className="w-[44px] lg:w-[60px] xl:w-[80px]"
                  src={OptikSeis}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[90px] lg:w-[120px] xl:w-[157px]"
                  src={SiloamHospital}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[82px] lg:w-[92px] xl:w-[122px]"
                  src={DoughLab}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[38px] lg:w-[45px] xl:w-[60px]"
                  src={Mandom}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[73px] lg:w-[95px] xl:w-[125px]"
                  src={Brodo}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[132px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[79px] lg:w-[90px] xl:w-[118px]"
                  src={Decathlon}
                  alt=""
                />
              </div>
              <div className="w-[106px] h-[48px] lg:w-[101px] xl:w-[173px] lg:h-[60px] xl:h-[78px] flex items-center justify-center">
                <img
                  className="w-[36px] lg:w-[47px] xl:w-[62px]"
                  src={Erigo}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Customer
